export const REQUEST_IN_MEETING_DOCUMENT_UPLOAD = "request_in_meeting_document_upload";
export const NOTARY_INITIATED_DOCUMENT_REFRESH = "notary_initiated_document_refresh";
